import DefaultLogin from "src/components/feature/Login";

const Login = () => {
  return <DefaultLogin />;
};

export default Login;
